module.exports = __webpack_public_path__ + "hinted-Montserrat-ExtraBoldItalic.cd5de18fa2490c3338b0.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-ExtraBoldItalic.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-ExtraBoldItalic.eot
// module chunks = 1